import React__default from 'react';
import { StatusStyles, StatusButtonWrapperStyles } from './Status.styles.js';
import { STATUS_PROP_TYPES } from './status.constants.js';
import { Typography } from '../Typography/Typography.js';
import { StatusDisplay } from './StatusDisplay.js';
import Button from '../Inputs/Button/Button.js';

var StatusBase = function StatusBase(_ref) {
  var _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    title = _ref.title,
    children = _ref.children,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? undefined : _ref$buttonProps;
  var isChildrenString = typeof children === 'string';
  return React__default.createElement(StatusStyles, {
    "data-testid": testId
  }, React__default.createElement(StatusDisplay, {
    type: type
  }), React__default.createElement(Typography, {
    variant: "headingLarge"
  }, title), isChildrenString ? React__default.createElement(Typography, {
    variant: "bodyRegular"
  }, children) : children, buttonProps && React__default.createElement(StatusButtonWrapperStyles, null, React__default.createElement(Button, buttonProps, buttonProps.children)));
};
StatusBase.propTypes = STATUS_PROP_TYPES;
var StatusBase$1 = StatusBase;

export { StatusBase$1 as default };
//# sourceMappingURL=StatusBase.js.map
